<template>
  <vs-popup
    fullscreen
    :active.sync="isActive"
    id="transferReviewer"
    v-esc="escape"
    title="Transfer Detayları"
  >
    <inventory-entry-detail ref="inventoryEntryDetail"/>
    <vs-table
      v-if="stockTransfer.entriesForBranch && stockTransfer.entriesForBranch.length > 0"
      ref="table"
      :data="filteredList"
      :max-items="itemsPerPage"
    >
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row vs-type="flex" vs-w="12" class="mb-2">
          <vs-row vs-type="flex" vs-w="12" vs-align="center">
            <vs-col vs-type="flex" class="w-auto">
              <span class="text-medium-small2 bold text-primary">
                {{ stockTransfer.branch.name }}
              </span>
            </vs-col>
            <vs-col vs-type="flex" class="w-auto">
              <span class="text-medium-small weight-600 text-dark ml-2">
                {{ stockTransfer.created }}
              </span>
            </vs-col>
            <vs-col vs-type="flex" class="w-auto ml-auto">
              <vx-tooltip text="Excel Export" position="top" class="ml-2">
                <vs-button
                  @click="getExcel"
                  class="panel-action p-5 text-dark xlarge-button panel-action-box-shadow"
                  color="primary"
                  size="small"
                  icon-pack="feather"
                  icon="icon-download"
                >
                </vs-button>
              </vx-tooltip>
              <vs-button
                v-if="stockTransfer.status == 2 && $isCenterBranch()"
                type="gradient"
                @click="commitLatedTransfer(stockTransfer.id)"
                class="ml-2 sale-box-shadow"
                color="warning"
                size="small"
                icon-pack="feather"
                icon="icon-check"
              >
                Onayla !
              </vs-button>
            </vs-col>
          </vs-row>
        </vs-row>
        <div class="w-full d-flex align-center">
              <vs-input @input="setFilter" v-model="stockNameFilter" placeholder="Stok İsmi Ara"
                        class="stock-order-filter-input bg-white text-dark weight-600 w-64 text-small" size="small"/>
              <vs-button class="ml-2" v-if="stockNameFilter != ''"
                         size="small" radius color="danger" @click="stockNameFilter = ''; setFilter('')"
                         icon-pack="feather" icon="icon-x"/>
            </div>
      </div>

      <template slot="thead">
        <vs-th class="w-4/12">
          <vs-button
            icon-pack="feather"
            class="text-primary p-0 bold text-small"
            color="transparent"
          >Stok Kategorisi
          </vs-button>
        </vs-th>
        <vs-th class="w-4/12">
          <vs-button
            icon-pack="feather"
            class="text-primary p-0 bold text-small"
            :icon="
              tableOptions.sortBy == 'stock.RawMaterial.Name'
                ? sortingHeadIcon
                : null
            "
            color="transparent"
          >Stok Adı
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            icon-pack="feather"
            class="text-primary p-0 bold text-small"
            :icon="
              tableOptions.sortBy == 'quantityWhenSaved'
                ? sortingHeadIcon
                : null
            "
            color="transparent"
          >Sistemdeki Miktar
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            icon-pack="feather"
            class="text-primary p-0 bold text-small"
            :icon="
              tableOptions.sortBy == 'currentLeft' ? sortingHeadIcon : null
            "
            color="transparent"
          >Stok Sayımı
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <span
            class="w-full px-2 p-0 weight-600 text-primary text-medium-small text-center"
          >
            Birim
          </span>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            icon-pack="feather"
            class="w-full text-primary p-0 bold text-small"
            :icon="
                tableOptions.sortBy == 'currentLeft - quantityWhenSaved'
                  ? sortingHeadIcon
                  : null
              "
            color="transparent"
          >Fark
          </vs-button>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody style="text-align: center">
        <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">
          <vs-td class="w-4/12">
              <span class="w-full pr-2 weight-600 text-smaller">
                {{ tr.stock.categoryName }}
              </span>
          </vs-td>
          <vs-td class="w-4/12">
              <span class="w-full pr-2 weight-600 text-smaller">
                {{ tr.stock.name }}
              </span>
          </vs-td>

          <vs-td class="w-2/12">
              <span class="w-full weight-600 px-2 text-smaller text-center">
                {{ tr.quantityWhenSaved }}
              </span>
          </vs-td>
          <vs-td class="w-2/12">
            <vs-input
              :name="index + 1 + '.Sayım'"
              readonly
              v-model="tr.quantityTransfered"
              class="w-full bg-white"
              size="small"
            />
          </vs-td>
          <vs-td class="w-2/12">
              <span class="w-full weight-600 px-2 text-smaller text-center">
                {{ tr.unitName }}
              </span>
          </vs-td>
          <vs-td class="w-2/12 justify-center">
              <span
                v-if="tr.minus != 0"
                class="w-full weight-600 pl-2 text-smaller text-center"
                :class="{
                  'text-success': tr.minus == 0,
                  'text-danger': tr.minus != 0,
                }"
              >
                {{ (tr.minus > 0 ? "+" : "") + tr.minus.toFixed(2) }}
              </span>
            <feather-icon
              v-else
              icon="CheckIcon"
              svgClasses="h-4 w-4"
              class="ml-1 text-success"
            />
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <!-- <pagination-default
      class="mt-4"
      :setCurrentPage="tableOptions.pageIndex"
      :totalLenght="calculatePageLength"
      @currentPage="getCurrentPage"
    ></pagination-default> -->
  </vs-popup>
</template>

<script>
import InventoryEntryDetail from "@/views/pages/Reports/InventoryReport/InventoryEntryDetail";
import PaginationDefault from "../PaginationDefault";
import {
  getStockTransfer,
  commitLatedTransfer,
  getStockTransferExcel,
} from "@/api/MonthlyStockTransfer.js";

export default {
  data() {
    return {
      isActive: false,
      stockTransfer: {},
      transferId: null,
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      totalDataRow: 0,
      tableOptions: {},
      currentPage: 0,
      itemsPerPage: 20,
      stockNameFilter: "",
      filteredList: [],
    };
  },
  components: {PaginationDefault, InventoryEntryDetail},
  computed: {
    calculatePageLength() {
      let mod = this.totalDataRow % 20;
      return mod > 0
        ? (this.totalDataRow - mod) / 20 + 1
        : this.totalDataRow / 20;
    },
  },
  methods: {
    setFilter: _.debounce(function (val) {
      console.log(val);
      // this.isShow = false;
      console.log(this.stockTransfer.entriesForBranch);
      this.filteredList = this.stockTransfer.entriesForBranch.filter(function (str) {
        return str.stock.name.toLocaleLowerCase('tr-TR').includes(val.toLocaleLowerCase('tr-TR'))
      })
    }, 500),
    openEntryHistory(stockId) {
      this.$refs.inventoryEntryDetail.isActive = true;
      this.$refs.inventoryEntryDetail.stockId = stockId;
    },
    getExcel() {
      getStockTransferExcel(this.transferId, this.tableOptions)
        .then((res) => {
          if (res && res.status === 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let now = this.$now.date();
            link.setAttribute(
              "download",
              "Transfer Stok Listesi" + this.stockTransfer.created + ".xlsx"
            );
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    commitLatedTransfer(stockTransferId) {
      commitLatedTransfer(stockTransferId)
        .then((res) => {
          if (res && res.status == 200) {
            if (res.data) {
              this.$vs.notify({
                color: "success",
                title: "Onaylandı !",
                text: "Geç Transfer Onaylandı !",
              });
              this.$emit("reload");
              this.escape();
            } else
              this.$vs.notify({
                color: "warning",
                title: "Bilgilendirme !",
                text: "Seçili Transfer Daha Önceden Onaylanmış !",
              });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Transfer Onaylanamadı !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    getStockTransfer: function () {
      console.log(this.tableOptions);
      this.tableOptions.pageSize = 999;
      getStockTransfer(this.transferId, this.tableOptions)
        .then((res) => {
          if (res && res.status === 200) {
            this.stockTransfer = res.data;
            this.filteredList = res.data.entriesForBranch;
            this.totalDataRow = res.data.totalEntryCount;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Transfer Detayı Yüklenemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    escape() {
      if (this.isActive == true) {
        this.isActive = false;
      }
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
    initValues() {
      this.tableOptions = {
        sortBy: "stock.RawMaterial.Name",
        sortDirection: "asc",
        pageIndex: 0,
        pageSize: 20,
      };
      this.transferEntries = [];
    },
  },
  watch: {
    sortingHeadIconBool: function (val) {
      switch (val) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    isActive(val) {
      if (val) {
        this.initValues();
      } else {
        this.$emit("close");
      }
    },
    tableOptions: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.getStockTransfer();
        });
      },
    },
  },
};
</script>

<style>
#transferEntries {
  height: calc(100vh - 175px);
  overflow-y: auto;
}

#transferReviewer .vs-popup--content {
  max-height: calc(100vh - 87px) !important;
}

#transferReviewer #newTransferEntry:hover {
  border-color: rgba(var(--vs-primary), 1);
}
</style>
